// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2xi9e","title":"ClientInsurance_title__8NNdV","itemText":"ClientInsurance_itemText__2MLCS"};